(function () {
  'use strict';

  document.querySelectorAll('.eb-product').forEach(initEbProduct);

  function initEbProduct(root) {
    var sectionId = root.getAttribute('data-section-id');
    var variantsJson = window['EbProductVariants-' + sectionId];

    // Each piece is isolated: if one throws (e.g. bad variant data on a
    // specific product), it must not stop the others from wiring up.
    safeRun(function () { initAutoSwatchColors(root); });
    safeRun(function () { initGallery(root); });
    safeRun(function () { initTabs(root); });
    safeRun(function () { initQuantity(root); });
    safeRun(function () { initOptions(root, variantsJson); });
    safeRun(function () { initRecommendations(root); });
    safeRun(function () { initWishlist(root); });

    // Belt-and-suspenders: re-run the swatch coloring a moment later and
    // again once every resource on the page has finished loading. Cheap
    // (it just re-sets the same CSS variable) and makes the very first
    // paint's timing a non-issue if anything else on the page delays when
    // this section's markup is actually ready to be read.
    safeRun(function () { window.setTimeout(function () { initAutoSwatchColors(root); }, 500); });
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () { safeRun(function () { initAutoSwatchColors(root); }); });
    }
  }

  function safeRun(fn) {
    try {
      fn();
    } catch (err) {
      if (window.console && console.error) console.error('[eb-product]', err);
    }
  }

  // ---------- Color swatches (built-in name library) ----------
  // Any swatch the Liquid template couldn't resolve to an exact color name
  // is marked .eb-product__swatch--auto and still shows the plain gray
  // fallback circle at page-load time. This fills those in, in two passes:
  // 1. Exact match against the full value (mirrors eb-color-swatch.liquid).
  // 2. A "contains" pass that catches compound names built on a known
  //    color word — "Soft Blue", "Dusty Rose Pink" fall through pass 1 but
  //    get caught here via "blue" / "rose" or "pink". Order matters: more
  //    specific multi-word keys are checked before generic single-word ones.
  // This runs client-side (rather than as more Liquid) because Shopify caps
  // a section's Liquid complexity, and the exact-match list in
  // eb-color-swatch.liquid already uses most of that budget on its own.
  var COLOR_NAME_MAP = {
    'black': '#1a1a1a', 'white': '#ffffff', 'ivory': '#f5f0e6', 'off white': '#f5f0e6', 'off-white': '#f5f0e6',
    'cream': '#f2e8d5', 'beige': '#e3d5c0', 'tan': '#d2b48c', 'khaki': '#c3b091', 'camel': '#c19a6b',
    'taupe': '#8b7d6b', 'olive': '#6b6b3a', 'green': '#3a7d44', 'emerald': '#046307',
    'forest': '#2e4a2e', 'forest green': '#2e4a2e', 'hunter green': '#355e3b',
    'sage': '#9caf88', 'sage green': '#9caf88', 'mint': '#a8d8c9', 'teal': '#367588', 'turquoise': '#40c0c0',
    'navy': '#1b2a4a', 'navy blue': '#1b2a4a', 'blue': '#3a6ea5',
    'sky blue': '#a7c7e7', 'baby blue': '#a7c7e7', 'light blue': '#a7c7e7', 'royal blue': '#3457d5',
    'cobalt': '#1e5fa8', 'cobalt blue': '#1e5fa8', 'indigo': '#3b3a70',
    'periwinkle': '#a3b4e0', 'cornflower': '#a3b4e0', 'cornflower blue': '#a3b4e0',
    'seafoam': '#9fd8c8', 'seafoam green': '#9fd8c8', 'denim': '#4a6a8a', 'jade': '#00a86b',
    'army green': '#5c5a3a', 'olive green': '#5c5a3a', 'lime': '#9fd63b', 'chartreuse': '#9fd63b',
    'neon green': '#39ff14', 'neon yellow': '#eaff00', 'neon orange': '#ff5f1f', 'neon pink': '#ff2fb0',
    'red': '#b02e2e', 'crimson': '#c4212e', 'scarlet': '#c4212e', 'cherry': '#9e1b32',
    'brick': '#b5502d', 'terracotta': '#b5502d', 'terra cotta': '#b5502d',
    'maroon': '#5c1a1a', 'burgundy': '#6d1b2b', 'wine': '#6d1b2b', 'raspberry': '#a02255',
    'pink': '#e8a0b4', 'baby pink': '#f4c2c2', 'blush pink': '#f4c2c2', 'blush': '#e0a8a0', 'rose': '#e0a8a0',
    'dusty rose': '#c9959a', 'mauve': '#c9959a', 'hot pink': '#e0218a', 'fuchsia': '#e0218a', 'fuschia': '#e0218a', 'magenta': '#c2185b',
    'purple': '#6a4c93', 'lavender': '#c6b8e0', 'lilac': '#d7bde2', 'orchid': '#d7bde2',
    'violet': '#7b4fa0', 'amethyst': '#7b4fa0', 'plum': '#5b3256', 'eggplant': '#5b3256',
    'orange': '#d9752b', 'rust': '#a4502a', 'coral': '#e8836b', 'salmon': '#e58f7f',
    'peach': '#f4b896', 'apricot': '#f4b896', 'yellow': '#e0c341', 'mustard': '#c9a13b',
    'marigold': '#f3c13a', 'canary': '#f3c13a', 'canary yellow': '#f3c13a', 'gold': '#c9a646',
    'champagne': '#e8d7ae', 'bronze': '#8c6239', 'copper': '#b3651f',
    'brown': '#6b4a34', 'chocolate': '#4a2e1f', 'coffee': '#4b3621', 'espresso': '#4b3621',
    'mocha': '#8a6952', 'latte': '#8a6952', 'chestnut': '#5a3825', 'mahogany': '#5a3825', 'walnut': '#5a3825',
    'caramel': '#b6803a', 'honey': '#b6803a', 'butterscotch': '#b6803a',
    'sand': '#d9c7a3', 'sand dune': '#d9c7a3', 'wheat': '#d9c7a3', 'oatmeal': '#d9c7a3',
    'stone': '#b6a892', 'clay': '#b6a892', 'grey': '#8a8a8a', 'gray': '#8a8a8a',
    'light grey': '#c4c4c4', 'light gray': '#c4c4c4', 'slate': '#5b6b73', 'slate grey': '#5b6b73', 'slate gray': '#5b6b73',
    'charcoal': '#3a3a3a', 'gunmetal': '#3b3f42', 'graphite': '#3b3f42',
    'jet black': '#0b0b0b', 'onyx': '#0b0b0b', 'silver': '#c0c0c0', 'platinum': '#c0c0c0',
    'pearl': '#f7f5f0', 'bone': '#f7f5f0', 'snow': '#f7f5f0', 'snow white': '#f7f5f0',
    'multi': 'linear-gradient(135deg,#e8a0b4,#a7c7e7,#e0c341)',
    'multicolor': 'linear-gradient(135deg,#e8a0b4,#a7c7e7,#e0c341)',
    'multi-color': 'linear-gradient(135deg,#e8a0b4,#a7c7e7,#e0c341)',
    'print': 'linear-gradient(135deg,#e8a0b4,#a7c7e7,#e0c341)'
  };

  // Ordered so more specific / compound keys are tested before the generic
  // single-word keys they contain (e.g. "baby blue" before "blue", so a
  // value that already matched "baby blue" doesn't also stop early on the
  // plain "blue" check — doesn't matter for correctness here since we take
  // the first hit, but keeps results predictable and matched to the exact
  // list's own priorities).
  var COLOR_CONTAINS_ORDER = [
    'off white', 'off-white', 'ivory', 'cream', 'beige', 'khaki', 'camel', 'taupe',
    'sage', 'mint', 'forest', 'hunter', 'olive', 'emerald', 'lime', 'chartreuse',
    'seafoam', 'jade', 'teal', 'turquoise', 'green',
    'navy', 'baby blue', 'sky', 'royal', 'cobalt', 'periwinkle', 'cornflower', 'denim', 'indigo', 'blue',
    'crimson', 'scarlet', 'cherry', 'brick', 'terracotta', 'terra cotta', 'maroon', 'burgundy', 'wine',
    'raspberry', 'red',
    'blush', 'dusty rose', 'mauve', 'rose', 'hot pink', 'fuchsia', 'fuschia', 'magenta', 'pink',
    'lavender', 'lilac', 'orchid', 'violet', 'amethyst', 'plum', 'eggplant', 'purple',
    'rust', 'coral', 'salmon', 'peach', 'apricot', 'orange',
    'mustard', 'marigold', 'canary', 'champagne', 'gold', 'yellow',
    'bronze', 'copper', 'chocolate', 'coffee', 'espresso', 'mocha', 'latte',
    'chestnut', 'mahogany', 'walnut', 'caramel', 'honey', 'butterscotch', 'brown',
    'sand', 'wheat', 'oatmeal', 'stone', 'clay', 'slate', 'charcoal', 'gunmetal', 'graphite',
    'jet black', 'onyx', 'black',
    'silver', 'platinum', 'pearl', 'bone', 'snow', 'grey', 'gray', 'white',
    'multi', 'print'
  ];

  function findFuzzyColor(value) {
    for (var i = 0; i < COLOR_CONTAINS_ORDER.length; i++) {
      var key = COLOR_CONTAINS_ORDER[i];
      if (value.indexOf(key) !== -1 && COLOR_NAME_MAP[key]) {
        return COLOR_NAME_MAP[key];
      }
    }
    return null;
  }

  // Resolves a single color word/phrase only (exact, then fuzzy) — used both
  // for a whole swatch value and for each half of a split "Green/White"-style
  // dual-color value below.
  function resolveOneColor(word) {
    word = (word || '').trim();
    if (!word) return null;
    return COLOR_NAME_MAP[word] || findFuzzyColor(word);
  }

  // Splits a two-tone value like "Green/White", "Green & White", or
  // "Green and White" into its two color words. Returns null if the value
  // doesn't look like exactly two colors joined this way.
  function splitDualColor(value) {
    var parts = value.split(/\s*\/\s*|\s+(?:&|and)\s+/i).filter(function (p) { return p; });
    return parts.length === 2 ? parts : null;
  }

  function initAutoSwatchColors(root) {
    root.querySelectorAll('.eb-product__swatch--auto').forEach(function (swatch) {
      // Each swatch is wrapped individually: if a browser extension, another
      // app's script, or anything else on the page manages to throw while
      // this runs, forEach would otherwise abort on the very first item and
      // silently skip every swatch after it. Isolating each one means a
      // problem with one swatch can never block the rest from being colored.
      try {
        var value = (swatch.getAttribute('data-value') || '').trim().toLowerCase();

        // Exact match on the full value first (rare for a dual-color name,
        // but takes priority if it somehow is one).
        var hex = COLOR_NAME_MAP[value];

        // Then: does this look like two colors joined together ("Green/White",
        // "Green & White")? Checked BEFORE the whole-string fuzzy match below,
        // because that fuzzy match would otherwise catch "green" as a
        // substring of "green/white" and stop there, always picking only the
        // first color and never reaching the split logic at all.
        if (!hex) {
          var dualParts = splitDualColor(value);
          if (dualParts) {
            var colorA = resolveOneColor(dualParts[0]);
            var colorB = resolveOneColor(dualParts[1]);
            if (colorA && colorB) {
              // Diagonal 50/50 split circle rather than picking just one side.
              hex = 'linear-gradient(135deg, ' + colorA + ' 50%, ' + colorB + ' 50%)';
            } else {
              hex = colorA || colorB;
            }
          }
        }

        // Finally, whole-string fuzzy match for ordinary single-color names.
        if (!hex) hex = findFuzzyColor(value);

        if (hex) swatch.style.setProperty('--swatch-color', hex);
      } catch (err) {
        if (window.console && console.error) console.error('[eb-product] swatch color failed for', swatch, err);
      }
    });
  }

  // ---------- Gallery ----------
  function initGallery(root) {
    var thumbs = root.querySelectorAll('.eb-product__thumb');
    var slides = root.querySelectorAll('.eb-product__slide');
    if (!slides.length) return;

    initThumbScroll(root);

    function activate(mediaId) {
      thumbs.forEach(function (t) {
        var match = t.getAttribute('data-media-id') === mediaId;
        t.classList.toggle('is-active', match);
        t.setAttribute('aria-selected', match ? 'true' : 'false');
      });
      slides.forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-media-id') === mediaId);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activate(thumb.getAttribute('data-media-id'));
      });
    });

    function step(direction) {
      var ids = Array.prototype.map.call(slides, function (s) { return s.getAttribute('data-media-id'); });
      var activeIndex = 0;
      slides.forEach(function (s, i) { if (s.classList.contains('is-active')) activeIndex = i; });
      var nextIndex = (activeIndex + direction + ids.length) % ids.length;
      activate(ids[nextIndex]);
    }

    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
  }

  // ---------- Thumbnail column scrolling ----------
  function initThumbScroll(root) {
    var list = root.querySelector('.eb-product__thumbs');
    var upBtn = root.querySelector('[data-thumbs-up]');
    var downBtn = root.querySelector('[data-thumbs-down]');
    if (!list || (!upBtn && !downBtn)) return;

    function updateArrows() {
      var hasOverflow = list.scrollHeight > list.clientHeight + 1;
      if (upBtn) upBtn.hidden = !hasOverflow || list.scrollTop <= 1;
      if (downBtn) downBtn.hidden = !hasOverflow || list.scrollTop + list.clientHeight >= list.scrollHeight - 1;
    }

    function scrollStep(direction) {
      var thumb = list.querySelector('.eb-product__thumb');
      var stepSize = thumb ? thumb.offsetHeight + 12 : 100;
      list.scrollBy({ top: direction * stepSize, behavior: 'smooth' });
    }

    if (upBtn) upBtn.addEventListener('click', function () { scrollStep(-1); });
    if (downBtn) downBtn.addEventListener('click', function () { scrollStep(1); });
    list.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    // Images loading in can change scrollHeight after first paint.
    updateArrows();
    window.setTimeout(updateArrows, 300);
    list.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', updateArrows, { once: true });
    });
  }

  // ---------- Tabs ----------
  function initTabs(root) {
    var tabs = root.querySelectorAll('.eb-product__tab');
    var panels = root.querySelectorAll('.eb-product__tab-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab-target');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-tab-panel') === target;
          panel.classList.toggle('is-active', active);
          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  // ---------- Quantity ----------
  function initQuantity(root) {
    var input = root.querySelector('[data-qty-input]');
    if (!input) return;
    var dec = root.querySelector('[data-qty-decrease]');
    var inc = root.querySelector('[data-qty-increase]');
    if (dec) {
      dec.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val - 1);
      });
    }
    if (inc) {
      inc.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      });
    }
  }

  // ---------- Variant options ----------
  function initOptions(root, variants) {
    var hasVariantData = !!(variants && variants.length);
    // Scoped to the actual swatch/pill buttons only. The wrapping
    // ".eb-product__option" div also carries a data-option-index attribute
    // (for getSelectedOptions() to key off of), so a bare
    // '[data-option-index]' selector here would also match that div and
    // attach a second click handler to it. Since click events bubble from a
    // button up through its wrapping div, that second handler would re-fire
    // on every click, immediately undoing the correct selection (clearing
    // eb-is-selected on the whole group and blanking the value label, since
    // the div itself has no data-value).
    var optionButtons = root.querySelectorAll('.eb-product__swatch[data-option-index], .eb-product__pill[data-option-index]');
    if (!optionButtons.length) return;
    var variantIdInput = root.querySelector('[data-variant-id-input]');
    var addToCartBtn = root.querySelector('[data-add-to-cart]');
    var addToCartText = root.querySelector('[data-add-to-cart-text]');
    var priceWrap = root.querySelector('[data-price]');

    function getSelectedOptions() {
      var groups = {};
      root.querySelectorAll('.eb-product__option').forEach(function (group) {
        var index = group.getAttribute('data-option-index');
        var selected = group.querySelector('.eb-is-selected');
        groups[index] = selected ? selected.getAttribute('data-value') : null;
      });
      return groups;
    }

    function findMatchingVariant(selected) {
      if (!hasVariantData) return null;
      return variants.find(function (variant) {
        return Object.keys(selected).every(function (index) {
          return variant.options[index] === selected[index];
        });
      });
    }

    function updateUI(variant) {
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceWrap) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWrap.innerHTML =
            '<span class="eb-product__price-sale">' + variant.price_formatted + '</span>' +
            '<span class="eb-product__price-compare">' + variant.compare_at_price_formatted + '</span>';
        } else {
          priceWrap.innerHTML = '<span class="eb-product__price-regular">' + variant.price_formatted + '</span>';
        }
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
      }
      if (addToCartText) {
        addToCartText.textContent = variant.available ? addToCartText.getAttribute('data-available-label') || addToCartText.textContent : addToCartText.getAttribute('data-soldout-label') || 'Sold Out';
      }

      if (variant.featured_media_id) {
        var slide = root.querySelector('.eb-product__slide[data-media-id="' + variant.featured_media_id + '"]');
        var thumb = root.querySelector('.eb-product__thumb[data-media-id="' + variant.featured_media_id + '"]');
        if (slide) {
          root.querySelectorAll('.eb-product__slide').forEach(function (s) { s.classList.remove('is-active'); });
          slide.classList.add('is-active');
        }
        if (thumb) {
          root.querySelectorAll('.eb-product__thumb').forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          thumb.classList.add('is-active');
          thumb.setAttribute('aria-selected', 'true');
        }
      }

      if (window.history && root.getAttribute('data-product-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    // Store available add-to-cart labels for toggling text
    if (addToCartText) {
      addToCartText.setAttribute('data-available-label', addToCartText.getAttribute('data-available-label') || addToCartText.textContent.trim());
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Always do the basic visual selection first — this must work even
        // if the variant price/availability data below fails for any reason.
        var group = btn.closest('.eb-product__option');
        group.querySelectorAll('button').forEach(function (b) {
          b.classList.remove('eb-is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('eb-is-selected');
        btn.setAttribute('aria-pressed', 'true');

        var valueLabel = group.querySelector('[data-option-selected-value]');
        if (valueLabel) valueLabel.textContent = btn.getAttribute('data-value');

        try {
          var selected = getSelectedOptions();
          var matched = findMatchingVariant(selected);
          updateUI(matched);
        } catch (err) {
          /* Variant price/availability sync failed — selection above still stands. */
        }
      });
    });
  }

  // ---------- Recommendations ----------
  function initRecommendations(root) {
    var container = root.querySelector('[data-product-recommendations]');
    if (!container) return;
    var url = container.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var grid = doc.querySelector('.eb-product__recs-grid');
        if (grid) {
          container.innerHTML = grid.outerHTML;
        }
      })
      .catch(function () {
        /* silently ignore — recommendations are progressive enhancement */
      });
  }

  // ---------- Wishlist (placeholder hook) ----------
  function initWishlist(root) {
    var btn = root.querySelector('[data-wishlist-button]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var pressed = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      btn.classList.toggle('is-active', !pressed);
      // Hook a wishlist app's API here (e.g. window.wishlistApp.toggle(productId))
    });
  }
})();